import AjaxForm from "../modules/ajax-forms";

window.appPageCart = window.appPageCart || (function () {

    (new AjaxForm()).initAll();

    document.addEventListener('counter:error', function (e){
        let target = e.counterTarget
        if(e.counterErrorType === 'max' && target){
            let parent = target.parentNode
            while(parent && !parent.classList.contains('cart2__item') && parent.tagName !== 'BODY'){
                parent = parent.parentNode
            }

            if(parent.classList.contains('cart2__item')){
                let errorMessageElement = parent.querySelector('.js-cart2__item__error--max')
                if(errorMessageElement){
                    errorMessageElement.style.display = 'block'
                }
            }
        }
    })

    const S_CART_ITEM               = '.js-cart-item'
        , S_CART_ITEM_FORM_DELETE   = '.js-cart-item-form-delete'
        , C_CART_ITEM_DELETE        = 'js-cart-item-delete'
        , S_CART_ITEM_DELETE        = '.' + C_CART_ITEM_DELETE
        , S_DELETE_TOOLTIP          = '.js-delete-tooltip'
        , S_DELETE_TOOLTIP_YES      = `${S_DELETE_TOOLTIP} [data-yes]`
        , S_DELETE_TOOLTIP_NO       = `${S_DELETE_TOOLTIP} [data-no]`

    function getDefaultStore () {
        return {
            items: []
        }
    }

    function on (el, event, cb) {
        if (el) {
            event.split(' ').forEach(function (e) {
                el.removeEventListener(e, cb);
                el.addEventListener(e, cb)
            })
        }
    }

    function off (el, event, cb) {
        if (el) {
            event.split(' ').forEach(function (e) {
                el.removeEventListener(e, cb);
            })
        }
    }

    let store = getDefaultStore();

    const actions = {
        getDeleteElems (th) {
            let getters = th.cartItem.getters

            let form    = getters.formsDelete()[th.index]
            let tooltip = getters.tooltipsDelete()[th.index]

            return { form, tooltip }
        },
        closeDeleteTooltip (e) {
            e.preventDefault()
            let { form, tooltip } = actions.getDeleteElems(this)

            if (tooltip) {
                tooltip.classList.remove('show')
                off(form, 'clickout', actions.closeDeleteTooltip)
            }
        },
        toggleDeleteTooltip (e) {
            e.preventDefault()
            let { form, tooltip } = actions.getDeleteElems(this)

            if (tooltip) {
                tooltip.classList.toggle('show')

                if (tooltip.classList.contains('show')) {
                    on(form, 'clickout', actions.closeDeleteTooltip)
                } else {
                    off(form, 'clickout', actions.closeDeleteTooltip)
                }
            }
        },
        clickout (el) {
            if (window.clickout) {
                window.clickout.destroy(el);
                window.clickout.bindCustomEvent(el);
            } else {
                on(document, 'clickout:init', function () {
                    window.clickout.destroy(el);
                    window.clickout.bindCustomEvent(el);
                })
            }
        },
        clickDeleteYes (e) {
            let cartItem     = this.cartItem;
            let cartItemElem = cartItem.getters.elem();

            let product = {
                id:       cartItemElem.getAttribute('data-id'),
                name:     cartItemElem.getAttribute('data-name'),
                quantity: cartItemElem.getAttribute('data-quantity'),
                price:    cartItemElem.getAttribute('data-price'),
                category: cartItemElem.getAttribute('data-category'),
                brand:    cartItemElem.getAttribute('data-brand'),
            }

            console.log('remove', product)

            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                ecommerce: {
                    currencyCode: 'RUB',
                    remove:       {
                        products: [product]
                    }
                }
            });
        },
    };

    const cartItemConstructor = function (elem) {

        const store   = {
            formsDelete:          elem.querySelectorAll(S_CART_ITEM_FORM_DELETE),
            btnsDelete:           elem.querySelectorAll(S_CART_ITEM_DELETE),
            tooltipsDelete:       elem.querySelectorAll(S_DELETE_TOOLTIP),
            tooltipsDeleteYes:    elem.querySelectorAll(S_DELETE_TOOLTIP_YES),
            tooltipsDeleteNo:     elem.querySelectorAll(S_DELETE_TOOLTIP_NO),
            elem:                 elem,
        };
        const getters = {
            elem () {
                return store.elem
            },
            formsDelete () {
                return store.formsDelete
            },
            btnsDelete () {
                return store.btnsDelete
            },
            tooltipsDelete () {
                return store.tooltipsDelete
            },
        };

        let cartItem = {
            actions,
            getters
        };

        ['formsDelete', 'tooltipsDelete', 'tooltipsDeleteYes', 'tooltipsDeleteNo', 'btnsDelete'].forEach(function (v) {
            store[v].forEach(function (el, index) {
                el.index    = index
                el.cartItem = cartItem
            })
        });

        store.formsDelete.forEach(function (el) {
            actions.clickout(el)
        })

        store.btnsDelete.forEach(function (el) {
            on(el, 'click', actions.toggleDeleteTooltip)
        })

        store.tooltipsDeleteNo.forEach(function (el) {
            on(el, 'click', actions.closeDeleteTooltip)
        })

        store.tooltipsDeleteYes.forEach(function (el) {
            on(el, 'click', actions.clickDeleteYes)
        })

        return cartItem
    };

    function init () {
        store = getDefaultStore();

        document.querySelectorAll(S_CART_ITEM).forEach(function (value) {
            value.cartItem      = cartItemConstructor(value);
            value.cartItemStore = store;
            store.items.push(value.cartItem)
        })
    }


    init();
    return {
        init
    }
})();

